/**
 * Identifies a specific permission on a user group.
 * @see UserGroupPermission
 */
export var UserGroupPermissionId;
(function (UserGroupPermissionId) {
    UserGroupPermissionId["AccessReports"] = "ftr:permission:access-reports";
    /**
     * Users with this permission can:
     * - Access Recording/Courtroom/Courthouse/User Audit Logs
     * - Access Court System wide audit summaries
     */
    UserGroupPermissionId["AccessAuditLogs"] = "ftr:permission:access-audit-logs";
    UserGroupPermissionId["AdministerAgentConfigAndFileUpload"] = "ftr:permission:access-agent-config-and-file-upload";
    UserGroupPermissionId["AdministerBillingGroups"] = "ftr:permission:administer-billing-groups";
    UserGroupPermissionId["AdministerHolidays"] = "ftr:permission:administer-holidays";
    UserGroupPermissionId["AdministerLocations"] = "ftr:permission:administer-locations";
    /**
     * Users with this permission can create/edit/disable user groups and add/edit/remove users from court systems.
     */
    UserGroupPermissionId["AdministerUserGroups"] = "ftr:permission:administer-user-groups";
    /**
     * Users with this permission can configure:
     * - Turnaround (if transcript ordering is enabled) @see OR-107
     * - Due date calculation (if transcript ordering is enabled) @see OR-108
     * - Vocabulary @see OR-109
     */
    UserGroupPermissionId["ConfigureCourtSystem"] = "ftr:permission:configure-court-system";
    UserGroupPermissionId["DistributeTranscripts"] = "ftr:permission:distribute-transcripts";
    UserGroupPermissionId["PlaceOrdersInUnpublishedCourts"] = "ftr:permission:place-orders:unpublished-courts";
    UserGroupPermissionId["ProcessAudioOrders"] = "ftr:permission:process-audio-orders";
    UserGroupPermissionId["ProcessTranscriptOrders"] = "ftr:permission:process-transcript-orders";
    UserGroupPermissionId["ProcessRealTimeOrders"] = "ftr:permission:process-real-time-orders";
    UserGroupPermissionId["PlaybackRecordings"] = "ftr:permission:playback-recordings";
    UserGroupPermissionId["ReadStt"] = "ftr:permission:read-stt";
    UserGroupPermissionId["RequestStt"] = "ftr:permission:request-stt";
    UserGroupPermissionId["CaseInformation"] = "ftr:permission:case-information";
    UserGroupPermissionId["PlaybackHearings"] = "ftr:permission:playback-hearings";
    UserGroupPermissionId["ReadLogSheets"] = "ftr:permission:read-logsheets";
    UserGroupPermissionId["ShareRecordings"] = "ftr:permission:share-recordings";
    UserGroupPermissionId["ManageExporting"] = "ftr:permission:manage-exporting";
    UserGroupPermissionId["DownloadBundles"] = "ftr:permission:download-bundles";
    UserGroupPermissionId["RemoveTrms"] = "ftr:permission:remove-trms";
    UserGroupPermissionId["TranscribeRecordings"] = "ftr:permission:transcribe-recordings";
    // Control whether transcribers can read STT and log sheets associated with assigned jobs.
    UserGroupPermissionId["TranscriberReadStt"] = "ftr:permission:transcriber-read-stt";
    UserGroupPermissionId["TranscriberReadLogSheets"] = "ftr:permission:transcriber-read-logsheets";
    UserGroupPermissionId["ViewLicensing"] = "ftr:permission:view-licensing";
    /**
     * Recording vault permissions
     *
     * - Users with read permissions can only read
     * - Users with write permissions can only write
     *
     * Admin users should have both read and write permissions
     */
    UserGroupPermissionId["ReadRecordingVault"] = "ftr:permission:read-recording-vault";
    UserGroupPermissionId["WriteRecordingVault"] = "ftr:permission:write-recording-vault";
    UserGroupPermissionId["SealContent"] = "ftr:permission:seal-content";
    UserGroupPermissionId["AccessSealedContent"] = "ftr:permission:access-sealed-content";
    UserGroupPermissionId["ViewRealTimeRecorders"] = "ftr:permission:view-producers";
    UserGroupPermissionId["ManageRealtimeRecorders"] = "ftr:permission:manage-producers";
    UserGroupPermissionId["AdvancedRealtimeRecorderConfiguration"] = "ftr:permission:advanced-producer-configuration";
    UserGroupPermissionId["ManageWhenCourtroomIsOnTheRecord"] = "ftr:permission:manage-when-the-courtroom-is-on-the-record";
    UserGroupPermissionId["AccessOffTheRecordContent"] = "ftr:permission:access-off-the-record-content";
    UserGroupPermissionId["ManagePastSessions"] = "ftr:permission:modify-session-times";
    /**
     * DJ Permissions
     */
    UserGroupPermissionId["ModerateProceedings"] = "ftr:permission:moderate-proceedings";
})(UserGroupPermissionId || (UserGroupPermissionId = {}));
